export enum FieldType {
  Text = 'text',
  Picker = 'picker',
  Chips = 'chips',
  MultiSelect = 'multiSelect',
}

export interface ITradesValues {
  isSupervisor: boolean | null;
  isAffiliatedToLaborUnion: boolean | null;
  isSkilled: boolean | null;
  laborUnionNumber: string;
  trades: string[];
  otherTradesList: Array<{ isSaved: boolean; OtherText: string }>;
}

export interface IField {
  id: keyof ITradesValues;
  name: string;
  type: FieldType;
  isRequired: boolean;
  isVisible: boolean;
  showSkippableIndicator?: boolean;
  isSkippable?: boolean;
  skippableTill?: number;
  testId?: string;
  options?: Array<{ name: string; id: string }>;
  mappedOptions?: Array<{ label: string; value: any }>;
  selectedOption?: { label: string; value: any } | null;
  selectedChips?: Array<{ label: string; value: any }>;
  extraChips?: Array<{ label: string; value: string }>;
  onChange?: (value: any) => void;
  onExtraChipRemove?: (chipToRemove: { label: string; value: string }) => void;
  otherTrades?: Array<{ isSaved: boolean; OtherText: string }>;
  savedOtherTrades?: Array<{ name: string; id: string }>;
  addOption?: boolean;
}
